var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row align-items-center justify-content-center py-5",staticStyle:{"min-height":"100vh"}},[_c('Card',{attrs:{"msg":""}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }